import {
  FactFinderApiResponse,
  FactFinderProductResponse,
} from 'commerce/factFinder/types';
import { getProductsByReferenceKeys } from 'commerce/scayle/product-management';
import { IAdaptedListProduct } from 'commerce/scayle/utils/adapter/types';

export const adaptProducts = async (ffResp?: FactFinderApiResponse) => {
  const keys = ffResp?.hits?.flatMap((item: FactFinderProductResponse) => [
    item.masterValues.referenceKey,
    ...(item.variantValues?.referenceKey
      ? [item.variantValues.referenceKey]
      : []),
  ]);

  if (!keys?.length) {
    return {
      data: {
        ...ffResp,
        hits: [],
      },
      error: null,
    };
  }

  const { response: products, error } = await getProductsByReferenceKeys(keys);

  if (!products || error) {
    return {
      data: {
        ...ffResp,
        hits: [],
      },
      error,
    };
  }

  const adaptedProducts = assignProductRatings(ffResp, products);

  return {
    data: {
      ...ffResp,
      hits: adaptedProducts as IAdaptedListProduct[],
    },
    error,
  };
};

const assignProductRatings = (
  ffResp?: FactFinderApiResponse,
  products?: IAdaptedListProduct[],
) => {
  if (!ffResp?.hits || !products) {
    return [];
  }

  /** Create a map for quick product lookup */
  const productMap = new Map<string, IAdaptedListProduct>();
  products.forEach((product) => {
    productMap.set(product.referenceKey, product);
    product.variants?.forEach((variant) => {
      if (variant.referenceKey) {
        productMap.set(variant.referenceKey, {
          ...product,
          /** Use unique key to avoid key duplication */
          id: variant.id,
        });
      }
    });
  });

  /** Reconstruct the product array in FactFinder order */
  return ffResp.hits
    .map((ffProduct: FactFinderProductResponse) => {
      const referenceKey =
        (ffProduct.variantValues as any)?.referenceKey ||
        ffProduct.masterValues.referenceKey;
      const product = productMap.get(referenceKey);

      if (!product) {
        return null;
      }

      return {
        ...product,
        id: product.id,
        ratingScore: Number(ffProduct.masterValues.ratingScore),
        ratingCount: Number(ffProduct.masterValues.ratingCount),
      };
    })
    .filter((product) => product !== null);
};
